module.exports = __webpack_public_path__ + "static/logo-46310ecd81b9ef2514b188acde828b33.png";